import script from "./BaseImageLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseImageLogo.vue?vue&type=script&setup=true&lang=ts"

import "./BaseImageLogo.vue?vue&type=style&index=0&id=285be7be&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/cap-emploi/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285be7be"]])

export default __exports__